export default __webpack_public_path__ + "static/media/netflix.f57e38e0.jpg";